import { strToNumber } from '@/library/utils/numbers';
import { FilterOperationType } from '@/library/types/table-query';

const NUMERIC_DAYS_FILTER_OPERATIONS: FilterOperationType[] = [
  'lastDays',
  'nextDays',
  'beforeDaysFromToday',
  'afterDaysFromToday'
];

export const isNumericDaysFilterOperation = (operation?: string): boolean =>
  !!operation && NUMERIC_DAYS_FILTER_OPERATIONS.includes(operation as FilterOperationType);

export const getNumericDaysFilterValue = (value?: string | number | null): string | null => {
  const numValue = strToNumber(value);

  return numValue !== null && Number.isInteger(numValue) && numValue >= 0 ? String(numValue) : null;
};

export const hasValidNumericDaysFilterValue = (operation?: string, value?: unknown): boolean => {
  if (!isNumericDaysFilterOperation(operation)) return true;

  if (value === null || value === undefined || value === '') return false;

  if (Array.isArray(value)) {
    return value.length > 0 && getNumericDaysFilterValue(String(value[0])) !== null;
  }

  return getNumericDaysFilterValue(String(value)) !== null;
};
